import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useApp } from '../app/AppContext';
import { useI18n } from '../i18n';
import { describeError } from './LobbyPage';

/**
 * `/j/<code>` —— 邀請連結的落地頁（C02 §4 的 `join_url` 就長這樣）。
 *
 * 使用者體驗上這頁應該「什麼都不用按」：
 *   進站 → 自動建立匿名身分（AppProvider 做的）→ 自動 POST /lobby/join/<code> → 進對局。
 * 失敗才顯示可操作的畫面。
 */
export function JoinPage() {
  const { code = '' } = useParams();
  const { api, guestState } = useApp();
  const { t } = useI18n();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [tried, setTried] = useState(false);

  useEffect(() => {
    if (guestState !== 'ready' || tried || !code) return;
    setTried(true);
    api
      .joinByCode(code.toUpperCase())
      .then((r) => navigate(`/m/${encodeURIComponent(r.match_id)}`, { replace: true }))
      .catch((e: unknown) => setError(describeError(e, t)));
  }, [api, guestState, code, tried, navigate, t]);

  if (error) {
    return (
      <div className="notice notice--error stack stack--tight">
        <strong>{t('invite.expired')}</strong>
        <span className="faint">{error}</span>
        <Link className="btn btn--sm" to="/">
          {t('match.backToLobby')}
        </Link>
      </div>
    );
  }

  return (
    <p className="muted" aria-live="polite">
      {guestState === 'ready' ? t('invite.joining') : t('guest.creating')}
    </p>
  );
}
